import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, useHistory } from "react-router-dom";
import ErrorLabel from '../../../../component/error_label';
import toast from 'react-hot-toast'
import { SUB_DIRECTORY } from "../../../../common/constant";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../common/app_constant";
import { actionNewPassword, actionVerifyToken, resetNewPasswordResponse, resetVerifyTokendResponse } from "../store";
import Loader from "../../../../component/page_loader";



const NewPassword = (props) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    let params = useParams()


    const { newPassword, verifyToken } = useSelector((state) => ({
        ...state.publicStore
    }))

    const {
        register,
        formState: { errors },
        watch,
        handleSubmit,
    } = useForm({
        defaultValues: {

        },
    });
    const password = useRef({});
    password.current = watch("password", "");

    const [validToken, setValidToken] = useState(false)

    useEffect(() => {
        if (params) {
            dispatch(actionVerifyToken({
                email: params?.emailid,
                token: params?.token
            }))
        }


    }, [params])




    useEffect(() => {
        if (verifyToken !== null) {
            dispatch(resetVerifyTokendResponse())
            if (verifyToken.result === true) {
                setValidToken(true)
            } else {
                setValidToken(true)
                navigate('/forgot-password')
                switch (verifyToken.status) {
                    case 402:
                        toast.error("Token Not Verified", {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        break;
                    default:
                }
            }
        }
    }, [verifyToken])

    useEffect(() => {
        if (newPassword !== null) {
            dispatch(resetNewPasswordResponse())
            if (newPassword.result === true) {
                toast.success(newPassword.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
                navigate('/login')
            } else {
                switch (newPassword.status) {
                    default:
                }
            }
        }
    }, [newPassword])



    const onSubmit = async (data) => {
        dispatch(actionNewPassword({
            email: params?.emailid,
            password: data.password,
            token: params?.token,
            password_confirmation: data.confirm_password
        }))

    };

    return (

        <div className="cover">
            <section>
                <div className="mt-5">
                    <div className="container-xxl container-fluid">
                        <div className="row d-flex justify-content-center align-items-center py-5">
                            <div className="col-md-9 col-lg-6">
                                <h1 class="">
                                    Track your policies <br />
                                    <span class="fw-bold">hassle-free</span>
                                </h1>
                                <p class="mt-3">
                                    Automate your day-to-day insurance administration processes with PINC’s admin dashboard.  Keep a track of your on-going and expired policies. The dashboard offers a set of tools like Policy wallet to record any kind of insurance, Renewal reminders, Claim intimations, Active & Inactive policy hub, Company profile and Service support.
                                </p>
                                <div className="d-flex my-4">
                                    <div className="col-6 d-flex">
                                        <div className="w-50">
                                            <img
                                                src={`${SUB_DIRECTORY}/assets/images/1041916.png`}
                                                className="w-75"
                                                alt=""
                                            />
                                        </div>
                                        <div className="my-auto w-100">
                                            <b>Get Claim</b>
                                            <p className="mb-0">Assistance</p>
                                        </div>
                                    </div>
                                    <div className="col-6 d-flex">
                                        <div className="w-50">
                                            <img
                                                src={`${SUB_DIRECTORY}/assets/images/1041887.png`}
                                                className="w-75"
                                                alt=""
                                            />
                                        </div>
                                        <div className="my-auto w-100">
                                            <b>Explore</b>
                                            <p className="mb-0">Policies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 col-lg-5 offset-lg-1">
                                {
                                    validToken === false ?
                                        <Loader />
                                        :
                                        <div className="card shadow">
                                            <div className="card-body">
                                                <form noValidate
                                                    autoComplete="off"
                                                    onSubmit={handleSubmit(
                                                        onSubmit
                                                    )}>
                                                    <div className="align-items-center justify-content-center justify-content-lg-start mb-3">
                                                        <p className="lead fw-bold me-3 text-secondary">Set new password</p>
                                                    </div>
                                                    {/* create new Password input */}
                                                    <div className="form-outline mb-3">
                                                        <label className="form-label" htmlFor="password">
                                                            Create new password <span className='text-danger'>*</span>
                                                        </label>
                                                        <input
                                                            type="password"
                                                            id="password"
                                                            className="form-control form-control-lg"
                                                            placeholder="Enter password"
                                                            {...register(
                                                                "password",
                                                                {
                                                                    required: "This is required.",
                                                                    pattern: {
                                                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%~`'*#?&])[A-Za-z\d@$!%*?~`'#&]{8,20}$/,
                                                                        message: 'The password must contain one uppercase character, one lowercase character, one special character and one number.'
                                                                    },
                                                                    maxLength: {
                                                                        value: 15,
                                                                        message: "Password must be of minimum 8 characters and maximum 15 characters."
                                                                    },
                                                                    minLength: {
                                                                        value: 8,
                                                                        message: "Password must be of minimum 8 characters and maximum 15 characters."
                                                                    },
                                                                }
                                                            )}
                                                        />
                                                        {errors.password && (
                                                            <ErrorLabel
                                                                message={
                                                                    errors
                                                                        .password
                                                                        ?.message
                                                                }
                                                            />
                                                        )}                                              </div>
                                                    {/*re-enter Password input */}
                                                    <div className="form-outline mb-3">
                                                        <label className="form-label" htmlFor="confirm_password">
                                                            Re-enter password <span className='text-danger'>*</span>
                                                        </label>
                                                        <input
                                                            type="password"
                                                            id="confirm_password"
                                                            className="form-control form-control-lg"
                                                            placeholder="Re-enter password"
                                                            {...register("confirm_password", {
                                                                validate: (value) =>
                                                                    value === password.current ||
                                                                    "Password and Confirm Password must be the same.",
                                                                required: "This is required.",
                                                            })}
                                                        />
                                                        {errors.confirm_password && (
                                                            <ErrorLabel
                                                                message={
                                                                    errors
                                                                        .confirm_password
                                                                        ?.message
                                                                }
                                                            />
                                                        )}                                              </div>

                                                    <div className="text-center text-lg-start mt-4 pt-2">
                                                        <button type="submit" className="btn btn-primary w-100">
                                                            Submit
                                                        </button>
                                                        <p className="small fw-bold mt-2 pt-1 mb-0">
                                                            Already have an account?
                                                            <a onClick={() => {
                                                                navigate('/login')
                                                            }} style={{ cursor: 'pointer' }} className="link-danger">
                                                                &nbsp;Sign In
                                                            </a>
                                                        </p>
                                                    </div>
                                                </form>

                                            </div>
                                        </div>


                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    )

}

export default NewPassword;